/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalCadastrarNovoUsuarioAliases {
  AVATAR_0 = 'avatar-0',
  CHECKBOX_0 = 'checkbox-0',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_5 = 'field-5',
  FIELD_7 = 'field-7',
  FIELD_CONFIRMAR_EMAIL = 'field-confirmar-email',
  FIELD_CONFIRMAR_SENHA = 'field-confirmar-senha',
  FIELD_CPF_RG = 'field-cpf-rg',
  FIELD_TERMO = 'field-termo',
  FORM_DADOS = 'form-dados',
  FORM_INFORMACOES = 'form-informacoes',
  INPUT_0 = 'input-0',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_CPF_RG = 'input-cpf-rg',
  LINK_AVISO = 'link-aviso',
  LINK_TERMOS = 'link-termos',
  PANEL_AVISO = 'panel-aviso',
  PANEL_CADASTRAR_NOVO_USUARIO = 'panel-cadastrar-novo-usuario',
  PANEL_WIZARD = 'panel-wizard',
  RECAPTCHA_0 = 'recaptcha-0',
  RESULT_INFORMACOES = 'result-informacoes',
  TEXT_0 = 'text-0',
  WIZARD = 'wizard',
  WIZARD_STEP_DADOS = 'wizard-step-dados',
  WIZARD_STEP_INFORMACOES = 'wizard-step-informacoes',
}
export { ModalCadastrarNovoUsuarioAliases };
